// extracted by mini-css-extract-plugin
export var box = "_9q-1";
export var checkboxRow = "_9q-8";
export var checked = "_9q-2";
export var descriptionSpacer = "_9q-a";
export var disabled = "_9q-3";
export var icon = "_9q-6";
export var input = "_9q-0";
export var labelSpacer = "_9q-9";
export var medium = "_9q-5";
export var small = "_9q-4";
export var text = "_9q-7";